export function setAppCssVar(name: string, value: string): void {
	if (typeof document !== 'undefined' && document.documentElement?.style?.setProperty) {
		document.documentElement.style.setProperty(`--app-${name}`, value);
	}
}
